import { render, staticRenderFns } from "./AnnouncementMngListPage.vue?vue&type=template&id=36831bc1&"
import script from "./AnnouncementMngListPage.vue?vue&type=script&lang=js&"
export * from "./AnnouncementMngListPage.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementMngListPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports